<template>
  <div class="add-product" v-loading="fullscreenLoading">
    <div ref="headsection" class="head-section">
      <div style="width: 100%;height: 35px;margin-bottom: 20px">
        <div class="crumbs-navigation" style="width: 40%;float:left">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/main' }">
              {{ $t('addConfigModule.myQuotation') }}
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              <a @click="toSecond">
                {{ $t('addConfigModule.productConfigurationGroup') }}
              </a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              {{ $t('addConfigModule.addProduct') }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="tab-p" style="width: 60%;float: right">
          <div class="tab-b">
            <a>{{ $t('addConfigModule.addProduct') }}</a>
            <a @click="added">{{ $t('addConfigModule.productAdded') }}</a>
            <div class="clearfloat" />
          </div>
        </div>
      </div>
      <div class="clearfloat" />
      <el-form ref="form" :model="form" :inline="true" label-width="auto">
        <el-row :gutter="24">
          <el-col :span="4">
            <el-form-item prop="productLine">
              <div class="unitSearch">
                <el-select
                  style="display: block; width: 100%;"
                  v-model="form.productLine"
                  filterable
                  clearable
                  remote
                  :remote-method="getProdLineListBydebounce"
                  :placeholder="$t('addConfigModule.clickProductLine')"
                  :loading="loading"
                  value-key="lineId"
                  @change="onProdLineChange"
                  @clear="clearLine"
                >
                  <el-option
                    v-for="item in allProdLines"
                    :key="item.lineId"
                    :label="item.lineName"
                    :value="item"
                  />
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="productCategories" class="padding-left-7">
              <div class="unitSearch">
                <el-select
                  v-model="form.productCategories"
                  filterable
                  clearable
                  remote
                  :remote-method="getProductCategoriesBydebounce"
                  reserve-keyword
                  :placeholder="$t('addConfigModule.clickProductCategories')"
                  :loading="loading"
                  value-key="categoryId"
                  @change="onProductCategoriesChange"
                  @clear="clearCategories"
                >
                  <el-option
                    v-for="item in allProductCategories"
                    :key="item.categoryId"
                    :label="item.categoryName"
                    :value="item"
                  >
                    <span style="font-weight: bold">
                      {{ `[${$t('addConfigModule.productCategory')}]：` + item.categoryName }}
                    </span>
                    <span style="padding-left: 34px">
                      {{ `[${$t('addConfigModule.productLine')}]：` + item.lineName }}
                    </span>
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="productSeries" class="padding-left-7">
              <div class="unitSearch">
                <el-select
                  v-model="form.productSeries"
                  filterable
                  clearable
                  remote
                  :remote-method="getProductSeriesListBydebounce"
                  reserve-keyword
                  :placeholder="$t('addConfigModule.clickProductSeries')"
                  :loading="loading"
                  value-key="seriesId"
                  @change="onProductSeriesChange"
                  @clear="clearSeries"
                >
                  <el-option
                    v-for="item in allProductSeries"
                    :key="item.seriesId"
                    :label="item.seriesName"
                    :value="item"
                  >
                    <span style="font-weight: bold">
                      {{ `[${$t('addConfigModule.productRange')}]：` + item.seriesName }}
                    </span>
                    <span style="padding-left: 34px">
                      {{ `[${$t('addConfigModule.productCategory')}]：` + item.categoryName }}
                    </span>
                    <span style="padding-left: 34px">
                      {{ `[${$t('addConfigModule.productLine')}]：` + item.lineName }}
                    </span>
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- isFlag为true 不展示-->
            <el-form-item
              v-if="!this.configurationGroup.isService"
              class="padding-left-7"
            >
              <div class="unitSearch">
                <el-select
                  v-model="form.selectedHost"
                  ref="selectedHostSelect"
                  filterable
                  remote
                  :placeholder="$t('addConfigModule.fuzzyClickHost')"
                  :remote-method="getHostListBydebounce"
                  value-key="value"
                  @change="getHosts"
                >
                  <el-option
                    v-for="item in hostList"
                    :key="item.productCode"
                    :label="item.productName"
                    :value="{value:item.productCode,label:item.productName}"
                  />
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="keys" class="padding-left-7">
              <div class="unitSearch">
                <el-input
                  v-model="form.keys"
                  :placeholder="$t('addConfigModule.searchProductModel')"
                  @keyup.enter.native="seachForm"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="padding-left-7">
              <el-button type="primary" @click="seachForm()">
                {{ $t('addConfigModule.search') }}
              </el-button>
              <el-button @click="resetForm('form')">{{ $t('addConfigModule.reset') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px;">
          <el-col :span="5">
            <el-form-item :label="$t('addConfigModule.configurationGroupName') + '：'">
              {{ groupNameT }}&nbsp;
              <i class="el-icon-edit mr-8"
                 @click="editName"
                 style="vertical-align:middle;cursor:pointer;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item prop="productStatus" class="mr-8">
              <el-checkbox
                v-model="form.productStatus"
                true-label="0"
                false-label=""
                @change="seachForm"
              >
                {{ $t('addConfigModule.hideDeliSting') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item prop="isSpecialControlled" class="mr-8">
              <el-checkbox
                v-model="form.isSpecialControlled"
                true-label="true"
                false-label="false"
                @change="seachForm"
              >
                {{ $t('addConfigModule.hiddenFor') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item prop="showOpticalModule" class="mr-8">
              <el-checkbox
                v-model="form.showOpticalModule"
                true-label="true"
                false-label="false"
                @change="seachForm"
              >
                {{ $t('addConfigModule.hideLightModule') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item prop="showHost" class="mr-8">
              <el-checkbox
                v-model="form.showHost"
                true-label="true"
                false-label="false"
                @change="seachForm"
              >
                {{ $t('addConfigModule.accordingHost') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item prop="showHostAndOpticalModule" class="mr-8">
              <el-checkbox
                v-model="form.showHostAndOpticalModule"
                true-label="true"
                false-label="false"
                @change="seachForm"
              >
                {{ $t('addConfigModule.hostLightModule') }}
              </el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-top: 8px;">
            <span
              v-if="!configurationGroup.isService"
              class="my-collect"
              @click="openUserCollection"
            >
              <i class="el-icon-star-on" />
              {{ $t('addConfigModule.myFavorite') }}
            </span>
            <el-button
              type="primary"
              @click="createProductGroupSubItem"
              class="added-configuration"
            >
              {{ $t('addConfigModule.addProductConfigureGroup') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table" ref="headtable" style="margin-top: 2px; width: 100% ;overflow: hidden">
      <el-table
        id="table0001"
        show-header
        :data="ProductInitListVO"
        :height="tableHeight"
        :header-cell-style="{'text-align': 'left',background:'#eef1f6' }"
        ref="table"
        :border="true"
        style="width: 100%; background-color: #FFFFFF"
        v-if="isLoadTbale"
        :cell-style="changeStyle"
      >
        <el-table-column
          prop="productName"
          :label="$t('addConfigModule.productModel')"
          min-width="15%"
          align="left"
        >
          <template slot-scope="scope">
            <ProductNameFormation :scope="scope" />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('addConfigModule.productDescription')"
          :render-header="foo"
          min-width="20%"
          align="left"
        >
          <template slot-scope="scope">
            <long-text
              :text="scope.row.productDesc"
              :switch-flg="switchFlgP"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="productPrice"
          :label="$t('addConfigModule.priceRMB')"
          width="120"
          align="right"
          :formatter="priceFormat"
        >
          <!--增加价格高亮展示 mzy 2021年4月28日13:36:39-->
          <template slot-scope="scope">
            {{ priceFormat(scope.row,scope.column,scope.row.productPrice) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="purchaseQuantity"
          :label="$t('addConfigModule.theNumber')"
          width="102"
          align="left"
        >
          <template slot-scope="scope">
            <el-input-number
              ref="inputNumberRefs"
              size="mini"
              style="width: 80px"
              @change="changeNumberValue(scope.row)"
              controls-position="right"
              v-model="scope.row.purchaseQuantity"
              :min="0"
              :precision="0"
              :max="scope.row.productConfigInfo !== null &&
                scope.row.productConfigInfo !== '' ||
                scope.row.optionalType === 1 &&
                scope.row.subPropertyName === '主机' ? 1 : 99999 &&
                  configurationGroup.isService && scope.row.maxNum ? scope.row.maxNum:99999
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('addConfigModule.operation')"
          width="102"
          align="left"
        >
          <template slot-scope="scope">
            <el-button
              v-if="(scope.row.propertyCode ==='1001' || scope.row.propertyCode ==='1007' || scope.row.showPrecise ===1)"
              @click="handleClick(scope.row)" type="text" size="small"
            >
              {{ $t('addConfigModule.deploymentConfiguration') }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="productStatusStr"
          :label="$t('addConfigModule.status')"
          min-width="7%"
          align="left"
        >
          <template slot-scope="scope">
            <ProductStatusFomation :scope="scope.row" />
          </template>
        </el-table-column>
        <!-- 20260330 叶加亮同步需求隐藏此两列 -->
        <!-- <el-table-column
          prop="deliveryPeriod"
          :label="$t('addConfigModule.leadTime')"
          :show-overflow-tooltip="true"
          width="120"
          align="right"
          v-if="!configurationGroup.isService"
        >
          <template #header>
            {{ $t('addConfigModule.leadTime') }}
            <el-tooltip class="item" effect="light" placement="bottom-start">
              <template #content>
                <span v-if="$t('addConfigModule.Represents')">{{ $t('addConfigModule.Represents') }}<br></span>
                {{ $t('addConfigModule.Represents1') }}<br>
                {{ $t('addConfigModule.Represents2') }}<br>
                {{ $t('addConfigModule.Represents3') }}<br>
                {{ $t('addConfigModule.Represents4') }}
              </template>
              <i class="el-icon-warning-outline" style="color: #67C23A;transform: rotate(180deg);" />
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            {{ scope.row.deliveryPeriod }}{{ $t('addConfigModule.day') }} 
          </template>
        </el-table-column>
        <el-table-column
          prop="ordersPreparationTime"
          :label="$t('addConfigModule.orderPreparationTime')"
          :show-overflow-tooltip="true"
          width="120"
          align="right"
          v-if="!configurationGroup.isService"
        >
          <template #header>
            {{ $t('addConfigModule.orderPreparationTime') }}
            <el-tooltip class="item" effect="light" :content="$t('addConfigModule.orderPreparation')" placement="bottom-start">
              <i class="el-icon-warning-outline" style="color: #67C23A;transform: rotate(180deg);" />
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            {{ scope.row.ordersPreparationTime }}{{ $t('addConfigModule.day') }}
          </template>
        </el-table-column> -->
        <!-- 服务分类 -->
        <el-table-column
          prop="productPscType"
          :label="$t('addConfigModule.serviceClassification')"
          min-width="3%"
          align="left"
          v-if="!configurationGroup.isService"
        >
          <template #header>
            {{ $t('addConfigModule.serviceClassification') }}
            <el-tooltip class="item" effect="light" placement="bottom-start">
              <template #content>
                <span v-if="$t('addConfigModule.serviceProductTispTtile')">
                  {{ $t('addConfigModule.serviceProductTispTtile') }}<br>
                </span>
                {{ $t('addConfigModule.serviceProductTispContent1') }}<br>
                {{ $t('addConfigModule.serviceProductTispContent2') }}<br>
                {{ $t('addConfigModule.serviceProductTispContent3') }}<br>
                {{ $t('addConfigModule.serviceProductTispContent4') }}<br>
                {{ $t('addConfigModule.serviceProductTispContent5') }}
              </template>
              <i class="el-icon-warning-outline" style="color: #67C23A;transform: rotate(180deg);" />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('addConfigModule.more')"
          min-width="4%"
          align="left"
        >
          <template slot-scope="scope">
            <MoreContent :scope="scope" :is-partner="isPartner" />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('addConfigModule.collectionOperation')"
          min-width="4%"
          align="left"
          v-if="!configurationGroup.isService"
        >
          <template slot-scope="scope">
            <ProductOperate :scope="scope" />
          </template>
        </el-table-column>
      </el-table>
      <div class="clearfloat" />
      <div style="margin-top: 1px">
        <el-col :span="24" v-if="ifshow">
          <div class="grid-content" @click="loadingMore">
            <span v-if="notloading" class="icon">
              <i class="el-icon-circle-plus" />
            </span>
            <span v-if="!notloading" class="icon">
              <i class="el-icon-loading" />
            </span>{{ $t('addConfigModule.loadMore') }}
          </div>
        </el-col>
        <el-col :span="24" v-if="!ifshow">
          <div class="grid-content">{{ $t('addConfigModule.noMore') }}</div>
        </el-col>
      </div>
    </div>
    <!--编辑配置组弹出框-->
    <el-dialog
      :title="$t('addConfigModule.editConfigurationGroup')"
      width="450px"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="configurationGroup"
        :rules="rules"
        ref="configurationGroup"
        :inline="true"
        @submit.native.prevent
        @keyup.enter.native="updateConfiguration"
      >
        <el-form-item
          :label="$t('addConfigModule.configurationGroupName') + '：'"
          :label-width="formLabelWidth"
          prop="groupName"
        >
          <el-input
            style="width: 220px;"
            v-model.trim="configurationGroup.groupName"
            :placeholder="$t('addConfigModule.pleaseEnterTheContent')"
          />
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="dialogFormVisible = false"
        >
          {{ $t('addConfigModule.cancel') }}
        </el-button>
        <el-button
          type="primary"
          @click="updateConfiguration"
        >
          {{ $t('addConfigModule.determine') }}
        </el-button>
      </div>
    </el-dialog>
    <shoppingCart
      ref="mychild"
      :configuration-group="configurationGroup"
    />
    <UserCollection
      ref="myCollection"
      :configuration-group="configurationGroup"
    />
    <el-drawer
      ref="addProductDialogue"
      title=""
      size="100%"
      :modal="false"
      :visible.sync="drawer"
      :with-header="false"
      destroy-on-close
      direction="btt"
      @open="open"
    >
      <Config ref="config" :current-row="currentRow" :configuration-group="configurationGroup" />
    </el-drawer>
  </div>
</template>

<script>
import XEUtils from 'xe-utils';
import api from '../../api';
import longText from '../quotationlist/longText';
import eventBus from '@/utils/eventBus';
import {
  setStore,
  getStore,
  isPartnerM,
  isNotNull,
  removeStore,
  isControlled,
  isNewProduct,
  notesTextFormat
} from '@/utils/mUtils';
import { productPriceFormat, changeStyle } from '@/utils/numberFormater';
import MoreContent from '../selectproduct/MoreContent';
import shoppingCart from './shoppingCart';
import ProductNameFormation from '../components/ProductNameFormation';
import ProductStatusFomation from '../components/ProductStatusFomation';
import ProductTypeFormation from '../components/ProductTypeFormation';
import ProductOperate from '../components/ProductOperate';
import UserCollection from './UserCollection';
import { changeType } from '@/mixins/changeType';
import Config from '../addedproduct/Config';
export default {
  name: 'AdditionProduct',
  components: {
    longText,
    MoreContent,
    // ReplaceProduct,
    shoppingCart,
    ProductNameFormation,
    UserCollection,
    ProductOperate,
    Config,
    ProductStatusFomation,
  },
  mixins: [changeType],
  data () {
    return {
      isStep:1,
      changeNumberQuantity:{
        isMaxValue:0,
        isMinValue:0,
        isFixedOneYearCheck:0,
        isFixedTwoYearCheck:0,
        purchaseQuantityValue:0
      },
      popoverObj: {},
      drawer: false,
      currentRow: {},
      hostList: [],
      tableData: [],
      type: 2,
      tableHeight: 350,
      isLoadTbale: false,
      // username: getStore("username"),
      formLabelWidth: '174px',
      dialogFormVisible: false,
      projectName: '',
      configurationGroup: {
        projectId: '',
        groupId: '',
        groupName: '',
        isService: false
      },
      groupNameT: '',
      form: {
        productLine: '',
        productCategories: '',
        productSeries: '',
        lineProperty: [],
        keys: '',
        // hostKeys: '',
        selectedHost: '',
        preproduction: '',
        stopProduction: '',
        productStatus: '',
        isSpecialControlled: false,
        isProductPackage: false,
        showOpticalModule: false,
        showHost: false,
        showService: false,
        showHostAndOpticalModule: false
      },
      // 表单验证
      rules: {
        groupName: [
          { required: true, message: this.$t('addConfigModule.enterGroupName'), trigger: 'blur' },
          { max: 40, message: this.$t('addConfigModule.cannotExceedCharacters') }
        ]
      },
      allProdLines: [],
      allProductCategories: [],
      allProductSeries: [],
      allLinePropertyMap: [],
      // 页数
      page: 1,
      rows: 60,
      total: 0,
      ProductInitListVO: [],
      totalDissipation: 0,
      notloading: true,
      ifshow: true,
      fullscreenLoading: false,
      screenWidth: document.body.clientWidth, // 这里是给到了一个默认值 （这个很重要）
      loading: false,
      switchFlgP: true,
      totalRiilPrice: 0,
      isPartner: true,
      loadflg: true,
      // dialogProductRuleVisible:false,
      productRuleList: [],
      addProductIndexList: [],
      selectCount: 30,
      productPageSize: 60,
      resizeObserver: null,
      tableScrollWrapper: null,
      tableScrollHandler: null
    };
  },
  watch: {
    screenWidth (val) {
      this.screenWidth = val;
    }
  },

  methods: {
    handlePopover (item, productCode) {
      this.replaceProductModelAxios(productCode, item);
    },
    async replaceProductModelAxios (productCode, item) {
      try {
        const result = await api.replaceProductModel(productCode, item);
        if (result.data.status === '200') {
          this.popoverObj = result.data.data[0];
          this.popoverObj.newShelfTime = this.popoverObj.newShelfTime.substr(0, 10);
        } else {
          this.$notify.error(result.data.err);
        }
      } catch (e) {

      }
    },
    productPriceFormat,
    changeStyle,
    isNotNull,
    isControlled,
    isNewProduct,
    notesTextFormat,
    getQuantity () {
      this.$refs.mychild.getProductQuantity();
    },
    openUserCollection () {
      this.$refs.myCollection.openUserCollection();
      this.$refs.myCollection.openPackageCollection();
    },
    priceFormat (row, column, cellValue) {
      if (row.isRiil && row.retailPriceFloatingRate > 0) {
        if (row.retailPriceFloatingRate > 0) {
          return 'list*' + row.retailPriceFloatingRate;
        }
      }
      // 服务产品线 row.lineId === "25"
      if (this.configurationGroup.isService) {
        if (row.comments) {
         return row.comments;
        }else {
          return row.productPrice;
        }
      }
      return this.formatePrice(cellValue);
    },
    formatePrice (cellValue) {
      if (cellValue === 0) {
        return 0;
      }
      if (cellValue) {
        let value = Number(cellValue).toFixed(2);
        let intPart = Math.trunc(value);
        let intPartFormat = intPart
          .toString()
          .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        let value2Array = value.toString().split('.');
        if (value2Array.length === 2) {
          let floatPart = value2Array[1]; // 拿到小数部分
          intPartFormat = intPartFormat + '.' + floatPart;
          return intPartFormat;
        } else {
          return intPartFormat;
        }
      }
    },
    toProductQualificationList (productName) {
      let routeData = this.$router.resolve({
        name: 'ProductQualificationList',
        query: { productName: productName }
      });
      window.open(routeData.href, '_blank');
    },
    // 跳转至配置组
    toSecond () {
      this.$router.push({
        name: 'CreatOrderSecond/second',
        query: { projectId: this.configurationGroup.projectId, projectName: this.projectName }
      });
    },
    // tab 切换 添加产品
    tabAdd () {
      // secondGroupId : row.groupId,secondGroupName:row.groupName
      this.$router.push({
        name: 'AdditionProduct/add',
        params: {
          groupId: this.configurationGroup.groupId,
          projectId: this.configurationGroup.projectId,
          isService: this.configurationGroup.isService
        }
      });
    },
    // tab 切换 已添加产品
    added () {
      this.saveStatus();
      if (this.isService) {
        let flag = true;
      } else {
        let flag = false;
      }
      this.$router.push({
        name: 'AddedProduct/added',
        params: {
          groupId: this.configurationGroup.groupId,
          projectId: this.configurationGroup.projectId,
          isService: this.configurationGroup.isService
        },
        query: {
          routerPath: 'AdditionProduct'
        }
      });
    },
    // 修改配置组名称
    editName () {
      this.configurationGroup.groupName = this.groupNameT;
      this.dialogFormVisible = true;
    },
    updateConfiguration () {
      if (this.configurationGroup.groupName === this.groupNameT) {
        this.dialogFormVisible = false;
        return false;
      }
      this.$refs['configurationGroup'].validate(valid => {
        if (valid) {
          api
            .editConfigurationGroup(this.configurationGroup)
            .then(res => {
              let json = res.data;

              if (json.status === '200') {
                // 修改成功
                this.groupNameT = this.configurationGroup.groupName;
                this.$notify.success(this.$t('addConfigModule.editGroupNameSuccess'));
                this.dialogFormVisible = false;
              } else {
                // 修改失败
                this.$notify.error(json.data);
              }
            })
            .catch(() => {
              this.$notify.info(this.$t('addConfigModule.networkAnomaly'));
            });
          // this.dialogFormVisible = false;
        } else {
          this.dialogFormVisible = true;
        }
      });
    },
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    getProdLineListBydebounce: XEUtils.debounce(
      function (lineName) {
        this.getProdLineList(lineName);
      },
      200,
      { leading: false, trailing: true }
    ),
    // 获取产品线下拉列表
    getProdLineList (lineName) {
      let groupType = this.getGroupType();
      api.getProductLineList({
        params: { userCollection: '',
          groupType: groupType,
          lineName,
          pageSize: this.selectCount }
      })
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            // console.log(json.data)
            this.allProdLines = json.data;
            if (groupType == 1) {
              setStore(`AdditionProdLines`, this.allProdLines);
            } else {
              setStore(`AdditionProdLinesService`, this.allProdLines);
            }
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(() => {
          this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        });
    },
    // 清空产品线同时清空产品大类，产品系列
    clearLine () {
      // 产品大类
      this.allProductCategories = [];
      this.form.productCategories = '';
      // 产品系列
      this.allProductSeries = [];
      this.form.productSeries = '';
      // 产品分类
      this.allLinePropertyMap = [];
      this.form.lineProperty = [];
    },
    // 选择产品线改变事件
    onProdLineChange () {
      // 清空产品大类、系列和主机选中值
      this.form.productCategories = '';
      this.form.productSeries = '';
      this.form.lineProperty = [];
      this.getProductCategories();
      // 产品系列
      this.allProductSeries = [];
      this.form.productSeries = '';
      if (this.form.productLine != null && this.form.productLine.lineId != null) {
        this.getlineProperty();
      }
      this.getProductSeriesList();
      // 获取主机下拉列表
      this.getHostList();
      this.seachForm();
    },
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    getProductCategoriesBydebounce: XEUtils.debounce(
      function (categoryName) {
        this.getProductCategories(categoryName);
      },
      200,
      { leading: false, trailing: true }
    ),
    // 获取产品大类下拉列表
    getProductCategories (categoryName) {
      let param = {
        params: {
          lineId: this.form.productLine.lineId,
          userCollection: '',
          groupType: this.getGroupType(),
          categoryName,
          pageSize: this.selectCount
        }
      };
      api
        .getProductCategoriesList(param)
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.allProductCategories = json.data;
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(() => {
          this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        });
    },
    // 清空产品大类，同时清空产品系列
    clearCategories () {
      // 重置产品系列列表数据
      this.allProductSeries = [];
      this.form.productSeries = '';
      this.onProdLineChange();
    },
    // 选择产品大类改变事件
    onProductCategoriesChange () {
      // 清空产品系列选中值
      this.form.productSeries = '';
      this.seachForm();
      this.getProductSeriesList();
      // 获取主机下拉列表
      this.getHostList();
    },
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    getProductSeriesListBydebounce: XEUtils.debounce(
      function (seriesName) {
        this.getProductSeriesList(seriesName);
      },
      200,
      { leading: false, trailing: true }
    ),
    // 获取产品系列列表
    getProductSeriesList (seriesName) {
      let param = {
        params: {
          lineId: this.form.productLine.lineId,
          categoryId: this.form.productCategories.categoryId,
          userCollection: '',
          groupType: this.getGroupType(),
          seriesName,
          pageSize: this.selectCount
        }
      };
      api
        .getProductSeriesList(param)
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.allProductSeries = json.data;
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(() => {
          this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        });
    },
    onProductSeriesChange () {
      this.seachForm();
      // 获取主机下拉列表
      this.getHostList();
      // this.getProductSeriesList();
    },
    clearSeries () {
      // 重置产品系列列表数据
      this.allProductSeries = [];
      this.onProductCategoriesChange();
    },
    // 获取产品分裂列表
    getlineProperty () {
      let param = {
        params: {
          lineId: this.form.productLine.lineId
        }
      };
      api.getlineProperty(param).then(res => {
          let json = res.data;
          if (json.status === '200') {
            // console.log(this.allLinePropertyMap);
            this.allLinePropertyMap = json.data;
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(() => {
          this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        });
    },
    // 重置搜索框
    resetForm () {
      this.allProductCategories = [];
      this.allProductSeries = [];
      this.allLinePropertyMap = [];
      this.form.productLine = '';
      this.form.productCategories = '';
      this.form.productSeries = '';
      this.form.keys = '';
      this.form.selectedHost = '';
      // this.form.productStatus= '';
      // this.form.showOpticalModule=true;
      this.$nextTick(()=>{
        this.$refs.form.resetFields();
      });
      removeStore(`AdditionProduct`);
      removeStore(`AdditionProductService`);
      this.getProdLineList();
      this.getProductCategories();
      this.getProductSeriesList();
      this.getHostList();
      this.seachForm();
    },
    // 搜索功能
    seachForm () {
      this.ProductInitListVO = [];
      this.page = 1;
      let propertyCode = '';
      let fieldFatherID = '';
      if (this.form.lineProperty && this.form.lineProperty.length > 0) {
        propertyCode = this.form.lineProperty[0];
        if (this.form.lineProperty.length == 2) {
          fieldFatherID = this.form.lineProperty[1];
        }
      }
      let param = {
          lineId: this.form.productLine != '' ? this.form.productLine.lineId : '',
          categoryId: this.form.productCategories != '' ? this.form.productCategories.categoryId : '',
          seriesId: this.form.productSeries != '' ? this.form.productSeries.seriesId : '',
          propertyCode: propertyCode,
          fieldFatherID: fieldFatherID,
          keys: this.form.keys,
          preproduction: this.form.preproduction,
          stopProduction: this.form.stopProduction,
          productStatus: this.form.productStatus,
          isSpecialControlled: this.form.isSpecialControlled,
          isProductPackage: this.form.isProductPackage,
          showOpticalModule: this.form.showOpticalModule,
          showHost: this.form.showHost,
          showService: this.form.showService,
          showHostAndOpticalModule: this.form.showHostAndOpticalModule,
          page: 1,
          rows: 60,
          isServiceFlag: this.configurationGroup.isService,
          projectId: this.configurationGroup.projectId
      };
      this.fullscreenLoading = true;
      api
        .initProductList(param)
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.ProductInitListVO = json.data.list;
            this.total = json.data.total;
            this.ifshow = this.ProductInitListVO.length !== json.data.total;
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(() => {
          this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        })
        .then(() => {
          // 统一收尾：业务错误/网络异常同样复位遮罩
          this.fullscreenLoading = false;
        });
    },
    resetSelectedHost () {
      this.form.selectedHost = null;
    },
    // 点击加载更多 / 表格滚动到底自动加载
    loadingMore (showButtonLoading = true) {
      // 数据已全部加载：直接收口为"无更多数据"，不打开遮罩、不发请求
      if (this.total > 0 && this.ProductInitListVO.length >= this.total) {
        this.ifshow = false;
        this.notloading = true;
        return;
      }
      // 加载中 / 保存中：直接返回，避免遮罩被置位后无人复位
      if (!this.loadflg) {
        return;
      }
      this.fullscreenLoading = true;
      if (showButtonLoading) {
        this.notloading = false;
      }
      this.loadflg = false;
      this.page += 1;
      let propertyCode = '';
      let fieldFatherID = '';
      if (this.form.lineProperty && this.form.lineProperty.length > 0) {
        propertyCode = this.form.lineProperty[0];
        if (this.form.lineProperty.length == 2) {
          fieldFatherID = this.form.lineProperty[1];
        }
      }
      let param = {
        lineId: this.form.productLine != '' ? this.form.productLine.lineId : '',
        categoryId: this.form.productCategories != '' ? this.form.productCategories.categoryId : '',
        seriesId: this.form.productSeries != '' ? this.form.productSeries.seriesId : '',
        propertyCode: propertyCode,
        fieldFatherID: fieldFatherID,
        keys: this.form.keys,
        preproduction: this.form.preproduction,
        stopProduction: this.form.stopProduction,
        productStatus: this.form.productStatus,
        isSpecialControlled: this.form.isSpecialControlled,
        isProductPackage: this.form.isProductPackage,
        showOpticalModule: this.form.showOpticalModule,
        showHost: this.form.showHost,
        showService: this.form.showService,
        showHostAndOpticalModule: this.form.showHostAndOpticalModule,
        page: this.page,
        rows: 60,
        isServiceFlag: this.configurationGroup.isService,
        projectId: this.configurationGroup.projectId
      };
      api
        .initProductList(param)
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.ProductInitListVO = [
              ...this.ProductInitListVO,
              ...json.data.list
            ];
            this.total = json.data.total;
            this.ifshow = this.ProductInitListVO.length < json.data.total;
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(() => {
          this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        })
        .then(() => {
          // 统一收尾：成功/业务错误/网络异常都复位遮罩、忙标志与按钮态
          this.loadflg = true;
          this.fullscreenLoading = false;
          this.notloading = true;
        });
    },
    // 初始加载添加产品列表
    initGetProductList () {
      let param = {
          lineId: '',
          categoryId: '',
          seriesId: '',
          keys: '',
          preproduction: this.form.preproduction,
          stopProduction: this.form.stopProduction,
          productStatus: this.form.productStatus,
          isSpecialControlled: this.form.isSpecialControlled,
          isProductPackage: this.form.isProductPackage,
          showOpticalModule: this.form.showOpticalModule,
          showHost: this.form.showHost,
          showService: this.form.showService,
          showHostAndOpticalModule: this.form.showHostAndOpticalModule,
          page: this.page,
          rows: this.rows,
          isServiceFlag: this.configurationGroup.isService,
          projectId: this.configurationGroup.projectId
      };
      this.fullscreenLoading = true;
      api
        .initProductList(param)
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.ProductInitListVO = [
              ...this.ProductInitListVO,
              ...json.data.list
            ];
            this.total = json.data.total;
            this.ifshow = this.ProductInitListVO.length != json.data.total;
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(e => {
          this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
          console.error('e', e);
        })
        .then(() => {
          // 统一收尾：业务错误/网络异常同样复位遮罩
          this.fullscreenLoading = false;
        });
    },
    getGroupType () {
      let groupType = 1;
      if (this.configurationGroup.isService) {
        groupType = 2;
      }
      return groupType;
    },
    changeNumberValue(value){
      // 是服务配置组 并且 minNum存在,并且选中值大于默认 0, 并且小于 minNum 直接把minNum赋值给当前选中值
      if(value.minNum !== null && value.purchaseQuantity<value.minNum && value.purchaseQuantity>0){
          value.purchaseQuantity=value.minNum;
        this.$nextTick(()=>{
          this.changeNumberQuantity.isMinValue=value.minNum;
          this.changeNumberQuantity.purchaseQuantityValue=value.purchaseQuantity;
        });
      }
    },
    // 添加至配置组
    createProductGroupSubItem (productInitList) {
      this.addProductIndexList = [];
      if (this.loadflg) {
        let productInitListVOS = [];
        if (productInitList && productInitList.length > 0) {
          productInitListVOS = productInitList;
        } else {
          this.ProductInitListVO.forEach((item, index) => {
            if (item.purchaseQuantity && item.purchaseQuantity > 0) {
              productInitListVOS.push(item);
              this.addProductIndexList.push(index);
            }
          });
        }
        if (productInitListVOS != null && productInitListVOS.length > 0 &&  productInitListVOS.minNum !== null && this.changeNumberQuantity.purchaseQuantityValue <= this.changeNumberQuantity.isMinValue) {
          this.loadflg = false;
          this.fullscreenLoading = true;
          let body = {
            groupId: this.configurationGroup.groupId,
            productInitListVOS: productInitListVOS,
            typeOptions: 1
          };
          api.createProductGroupSubItem(body).then(res => {
              let json = res.data;
              if (json.status === '200') {
                // 跳转到已添加产品
                // this.added();
                this.$notify.success(this.$t('addConfigModule.addGroupNameSuccess'));
                // this.dialogProductRuleVisible = false;
                this.clearProductList();
                this.$refs.mychild.getProductQuantity();
              } else {
                this.$notify.error(json.err);
              }
              this.fullscreenLoading = false;
              this.loadflg = true;
            })
            .catch(() => {
              this.loadflg = true;
              this.fullscreenLoading = false;
              this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
            });
        } else{
          this.loadflg = true;
          this.$message({
            showClose: true,
            duration: 800,
            message: this.$t('addConfigModule.changeNotProduct'),
            type: 'error'
          });
        }
      }
    },
    clearProductList () {
      if (this.addProductIndexList.length > 0) {
        this.addProductIndexList.forEach(item => {
          this.ProductInitListVO[item].purchaseQuantity = 0;
        });
      }
    },
    productDesc (val) {
      let cont = '';
      if (this.screenWidth <= 1440) {
        cont = val.length > 20 ? val.substring(0, 20) : val;
        return cont;
      } else {
        cont = val.length > 35 ? val.substring(0, 35) : val;
        return cont;
      }
    },
    changText (row) {
      if (row.ifShow === undefined) {
        this.$set(row, 'ifShow', true);
      } else {
        row.ifShow = !row.ifShow;
      }
    },
    numberChange (index) {
      if (this.ProductInitListVO[index].purchaseQuantity == undefined) {
        this.$set(this.ProductInitListVO[index], 'purchaseQuantity', 1);
        this.$nextTick(() => {
          this.ProductInitListVO[index].purchaseQuantity = 0;
        });
      }
    },
    foo (h, { column }) {
      if (column.label) {
        return h('span', {}, [
          h('span', [column.label]),
          h(
            'button',
            {
              attrs: {
                style: 'float:right;color:#3fbbdc;border:none;border-radius:5px;height:2rem'
              },
              on: {
                click: () => {
                  this.expandDiscribe();
                }
              }
            },
            [this.$t('addConfigModule.expandOrCloseAll')]
          )
        ]);
      }
    },
    expandDiscribe () {
      // longText.expandDisc();
      this.switchFlgP = !this.switchFlgP;
      eventBus.$emit('longTextDisc');
    },
    getRiilPrice () {
      if (this.totalRiilPrice == 0) {
        api.getRiilProductTotalPriceByProjectId(this.configurationGroup.projectId).then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.totalRiilPrice = json.data;
          }
        });
      }
    },
    saveStatus () {
      let param = {
        params: {
          productLine: this.form.productLine != '' ? this.form.productLine : '',
          productCategories: this.form.productCategories != '' ? this.form.productCategories : '',
          productSeries: this.form.productSeries != '' ? this.form.productSeries : '',
          lineProperty: this.form.lineProperty && this.form.lineProperty.length > 0 ? this.form.lineProperty : [],
          keys: this.form.keys,
          preproduction: this.form.preproduction,
          stopProduction: this.form.stopProduction,
          productStatus: this.form.productStatus,
          isSpecialControlled: this.form.isSpecialControlled,
          isProductPackage: this.form.isProductPackage,
          showOpticalModule: this.form.showOpticalModule,
          showHost: this.form.showHost,
          showService: this.form.showService,
          showHostAndOpticalModule: this.form.showHostAndOpticalModule,
          page: this.page,
          rows: this.rows,
          isServiceFlag: this.configurationGroup.isService,
          projectId: this.configurationGroup.projectId
        }
      };
      if (this.configurationGroup.isService) {
        setStore(`AdditionProductService`, param);
        console.log('AdditionProductService', param);
      } else {
        setStore(`AdditionProduct`, param);
        console.log('AdditionProduct', param);
      }
    },
    initData (param) {
      if (this.configurationGroup.isService) {
        let lineList = JSON.parse(getStore(`AdditionProdLinesService`));
        if (lineList && lineList != null) {
          this.allProdLines = lineList;
        } else {
          this.getProdLineList();
        }
      } else {
        let lineList = JSON.parse(getStore(`AdditionProdLines`));
        if (lineList && lineList != null) {
          this.allProdLines = lineList;
        } else {
          this.getProdLineList();
        }
      }
      if (param) {
        let obj = JSON.parse(param);
        if (obj.params.productLine) {
          this.form.productLine = obj.params.productLine;
          if (obj.params.lineProperty) {
            this.getlineProperty();
            this.form.lineProperty = obj.params.lineProperty;
          }
        }
        this.getProductCategories();
        this.form.productCategories = obj.params.productCategories;
        if (obj.params.productCategories) {
          this.getProductSeriesList();
          this.form.productSeries = obj.params.productSeries;
        }
        this.form.keys = obj.params.keys;
        this.form.preproduction = obj.params.preproduction;
        this.form.stopProduction = obj.params.stopProduction;
        this.form.productStatus = obj.params.productStatus;
        this.form.isSpecialControlled = obj.params.isSpecialControlled;
        this.form.isProductPackage = obj.params.isProductPackage;
        this.form.showOpticalModule = obj.params.showOpticalModule;
        this.form.showHost = obj.params.showHost;
        this.form.showService = obj.params.showService;
        this.form.showHostAndOpticalModule = obj.params.showHostAndOpticalModule;
        this.form.lineProperty = obj.params.lineProperty;
        this.seachForm();
      } else {
        // this.getProdLineList();
        this.getProductCategories();
        this.getProductSeriesList();
        this.initGetProductList();
      }
    },
    scollHeight () {
      this.$nextTick(() => {
        const screenH = document.documentElement.clientHeight;
        const tableTop = this.$refs.headtable
          ? this.$refs.headtable.getBoundingClientRect().top
          : 0;
        // 表格下方保留加载更多/无更多数据操作区的高度，避免被视口裁切。
        this.tableHeight = Math.max(screenH - tableTop - 60, 300);
        this.isLoadTbale = true;
        this.$nextTick(() => {
          this.bindTableScroll();
          if (this.$refs.table && this.$refs.table.doLayout) {
            this.$refs.table.doLayout();
          }
        });
      });
    },
    bindTableScroll () {
      const table = this.$refs.table;
      const wrapper = table && table.bodyWrapper;
      if (!wrapper || this.tableScrollWrapper === wrapper) {
        return;
      }
      this.unbindTableScroll();
      this.tableScrollWrapper = wrapper;
      // 节流：滚动事件高频触发，200ms 内最多处理一次。
      // 必须显式带 trailing：xe-utils 的 throttle 默认只保留 leading，
      // 会把"正好滚到底"的最后一次滚动事件丢掉（滚动停止后不再有事件，到底就不会自动加载）。
      this.tableScrollHandler = XEUtils.throttle(() => {
        // 无更多数据 / 加载中 / 保存中：不触发加载
        if (!this.ifshow || !this.loadflg) {
          return;
        }
        if (wrapper.scrollTop + wrapper.clientHeight >= wrapper.scrollHeight - 20) {
          this.loadingMore(false);
        }
      }, 200, { leading: true, trailing: true });
      wrapper.addEventListener('scroll', this.tableScrollHandler);
    },
    unbindTableScroll () {
      if (this.tableScrollWrapper && this.tableScrollHandler) {
        this.tableScrollWrapper.removeEventListener('scroll', this.tableScrollHandler);
      }
      this.tableScrollWrapper = null;
      this.tableScrollHandler = null;
    },
    handleWindowResize: XEUtils.debounce(function () {
      this.scollHeight();
    }, 150),
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    getHostListBydebounce: XEUtils.debounce(
      function (productName) {
        this.getHostList(productName);
      },
      200,
      { leading: false, trailing: true }
    ),
    getHostList (productName) {
      // 清空选中的主机
      let param = {
        'lineID': this.form.productLine.lineId,
        'categoryID': this.form.productCategories.categoryId,
        'seriesID': this.form.productSeries.seriesId,
        productName,
        pageSize: this.productPageSize
      };
      this.fullscreenLoading = true;
      api.getHostList(param).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.hostList = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        // this.fullscreenLoading=false;
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
      });
      this.fullscreenLoading = false;
    },
    getHosts (product) {
      const { value, label } = product;
      if (!value && !label) {
        return false;
      }
      let propertyCode = '';
      let fieldFatherID = '';
      if (this.form.lineProperty && this.form.lineProperty.length > 0) {
        propertyCode = this.form.lineProperty[0];
        if (this.form.lineProperty.length === 2) {
          fieldFatherID = this.form.lineProperty[1];
        }
      }
      let codeParams={
        lineId: this.form.productLine !== '' ? this.form.productLine.lineId : '',
        categoryId: this.form.productCategories !== '' ? this.form.productCategories.categoryId : '',
        seriesId: this.form.productSeries !== '' ? this.form.productSeries.seriesId : '',
        // propertyCode: propertyCode,
        productcode: value,
        fieldFatherID: fieldFatherID,
        keys: this.form.keys,
        preproduction: this.form.preproduction,
        stopProduction: this.form.stopProduction,
        productStatus: this.form.productStatus,
        isSpecialControlled: this.form.isSpecialControlled,
        isProductPackage: this.form.isProductPackage,
        showOpticalModule: this.form.showOpticalModule,
        showHost: this.form.showHost,
        showService: this.form.showService,
        showHostAndOpticalModule: this.form.showHostAndOpticalModule,
        page: this.page,
        rows: 60,
        isServiceFlag: this.configurationGroup.isService,
        projectId: this.configurationGroup.projectId
      };
      // let params = {
      //   lineId: this.form.productLine !== '' ? this.form.productLine.lineId : '',
      //   categoryId: this.form.productCategories !== '' ? this.form.productCategories.categoryId : '',
      //   seriesId: this.form.productSeries !== '' ? this.form.productSeries.seriesId : '',
      //   productcode: value,
      //   page: 1,
      //   rows: 1
      // };
      api.initProductList(codeParams).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.handleClick(json.data.list[0]);
        } else {
          this.$notify.error(json.err);
        }
      });
    },
    handleClick (row) {
      row.isAddition = true;
      this.currentRow = row;
      this.drawer = true;
    },
    // 抽屉显示触发
    open () {
      this.$nextTick(function () {
        // 调用接口获取初始化数据f
        this.$refs.config.getData(this.currentRow);
        // 给弹出框中的组件赋值高度，使其可以超出滚动
        this.$refs.config.height = this.$refs.addProductDialogue.$refs.drawer.offsetHeight;
      });
    },
    getUserSettings () {
      api.getUserSettings().then(res => {
        let json = res.data;
        if (json.status === '200') {
          if (json.data.searchConditions != null) {
            let searchConditions = JSON.parse(json.data.searchConditions);
            if (searchConditions) {
              if (searchConditions.preproduction === true) {
                this.form.preproduction = '1';
              }
              if (searchConditions.stopProduction === true) {
                this.form.stopProduction = '2';
              }
              if (searchConditions.productStatus === true) {
                this.form.productStatus = '0';
              }
              this.form.isSpecialControlled = searchConditions.isSpecialControlled;
              this.form.showOpticalModule = searchConditions.showOpticalModule;
              this.form.showHost = searchConditions.showHost;
              this.form.showService = searchConditions.showService;
              this.form.showHostAndOpticalModule = searchConditions.showHostAndOpticalModule;
            }
          }
          this.initGetProductList();
        } else {
          this.$notify.error(json.err);
        }
      });
    }
  },
  mounted () {
    this.projectName = this.$route.query.projectName;
    this.getHostList();
    this.scollHeight();
    window.addEventListener('resize', this.handleWindowResize);
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.handleWindowResize);
      this.resizeObserver.observe(this.$el);
    }
    this.isPartner = isPartnerM();
    // console.log("主页面",this.isPartner);
    this.groupNameT = this.$route.params.groupName;
    this.configurationGroup.groupId = this.$route.params.groupId;
    this.configurationGroup.projectId = this.$route.params.projectId;

    if (this.$route.params.isService == 'true') {
      this.configurationGroup.isService = true;
    } else if (this.$route.params.isService == 'false') {
      this.configurationGroup.isService = false;
    } else {
      this.configurationGroup.isService = this.$route.params.isService;
    }
    if (this.$route.params.routerPath && this.$route.params.routerPath === 'AddedProduct') {
      if (this.configurationGroup.isService) {
        this.initData(getStore(`AdditionProductService`));
      } else {
        this.initData(getStore(`AdditionProduct`));
      }
    } else {
      this.getProdLineList();
      this.getProductCategories();
      this.getProductSeriesList();
      this.getUserSettings();
    }
    this.getQuantity();
    eventBus.$on('seachForm', () => {
      this.seachForm();
    });
    eventBus.$on('resetSelectedHost', () => {
      this.resetSelectedHost();
    });
  },
  destroyed () {
    this.unbindTableScroll();
    window.removeEventListener('resize', this.handleWindowResize);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    eventBus.$off('seachForm');
    eventBus.$off('resetSelectedHost');
  },
};
</script>
<style lang="scss">
  @import "../../styles/product-common.css";
  .productCodeStyle:hover{
    color: dodgerblue;
    cursor: pointer;
  }
  .add-product{
    .el-dialog__header{
      text-align: left;
    }
    .dialog-footer{
      margin-top: 20px;
      text-align: right;
    }
  }
  .add-product .el-form-item{
    //width: 280px !important;
  }

  .add-product .table {
    margin-top: 0;
    margin-bottom: 0;
  }
  .add-product .head-section {
    height: 120px;
    padding-bottom: 2px;
    margin-bottom: 30px;
  }
  .add-product .table .grid-content {
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #36bade;
    background: rgba(54, 186, 222, 0.2);
    vertical-align: middle;
    cursor: pointer;
    margin-bottom: 1px;
  }

  .add-product .table .grid-content .icon {
    margin-right: 6px;
    font-size: 12px;
  }
  .add-product .el-button--primary:hover {
    color: #fff;
    background-color: #60c8e8 !important;
    border-color: #60c8e8 !important;
  }

  .add-product .el-form-item {
    float: left;
    margin-right: 0;
    margin-bottom: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .add-product .table .el-table .cell {
    white-space: normal;
  }

  /*设置描述*/
  .add-product .cell:hover .el-tag {
    border: 1px solid #36bade;
  }
  .add-product .el-tag {
    text-overflow: ellipsis;
    display: inline-block;
    border: transparent;
    margin: 0;
    cursor: pointer;
  }
  .add-product .el-tag img {
    width: 24px;
  }

  .add-product .head-section el-icon-edit-outline {
    vertical-align: middle;
  }
  @media screen and (max-width: 1366px) {
    .add-product table * {
      margin: 0;
      padding: 0;
    }
    .add-product .tab-p {
      margin-top: 0;
    }
    .add-product .table {
      margin-bottom: 0;
    }
  }
</style>
<style scoped lang="scss">
.add-product {
  .unitSearch{
    display: inline-block;
    //margin-right: -5px;
    ::v-deep .el-input{
      width:280px !important;
    }
    ::v-deep .el-input__inner{
      width:280px !important;
    }
    ::v-deep .el-input--suffix .el-input__inner{
      width:280px !important;
    }
    ::v-deep .el-input__icon{
      height:100%;
    }
  }
}
.mr-8{
  margin-right: 25px !important;
}
.added-configuration{
  height: 32px;
  color: #3fbbdc;
  border: 1px solid #3fbbdc !important;
  background-color: #FFFFFF !important;
}
</style>
